import firebase from "firebase";
import {firebaseConfig} from "../FIREBASE_CONFIG";
import {parseAllDatesDoc} from "../../framework/util/firebase/FireStoreUtils";

const firebaseApp = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.apps[0];
const db = firebase.firestore();
const MAX_QUERY = 500;

export const findByIds = async(ids) =>{

    if (!ids || !ids.length )
        return [];

    var jobs = [];
    for (const id of ids) {
        jobs.push(await findById(id));
    }

    return {data: jobs};


}

export const findById = async (id) => {

    if (!id)
        throw 'No pressjob id';


    const ref = db.collection('pressjobs').doc(id);

    try {
        const doc = await ref.get();

        if (!doc.exists)
            return null;
        else {
            const job = doc.data();
            parseAllDatesDoc(job);
            return (job);
        }

    } catch (error) {
        console.log(error);
        throw("Error getting documents: ", error);
    }


}




export const getJobsBetween = async (station, startDate, endDate, limit) => {

    if (!station)
        throw 'no station';

    // end date is optional
    if (!endDate)
        endDate = new Date();

    const siteId = station.siteId;
    if (!siteId)
        throw 'no site id';
    const stationName = station.name;
    if (!stationName)
        throw 'no station';

    console.log('Searching for jobs on ' + stationName + ' at ' + siteId + ' between ' + startDate + ' and ' + endDate);

    var jobs = [];

    //console.log('Querying for jobs on station date', {siteId, stationName, compareDate});
    var ref = db.collection('pressjobs')
        .where("device", "==", stationName)
        .where('facility', '==', siteId)
        .where('printingEnd', '>=', startDate)
        .where('printingEnd', '<=', endDate)
        .orderBy("printingEnd", "desc").limit(limit ? limit : MAX_QUERY);

    try {
        var snasphot = await ref.get();
        for(const doc of snasphot.docs){
            const job = {id: doc.id, ...doc.data()};
            //console.log('Pushing job data', job);
            jobs.push(job);
        }
    } catch (error) {
        console.log(error);
        throw("Error getting documents: ", error);
    }

    // Fix dates
    parseAllDatesDoc(jobs);

    return {data: jobs};

}

export const getAllJobsBetween = async (startDate, endDate, limit) => {

    // end date is optional
    if (!endDate)
        endDate = new Date();

    var jobs = [];

    //console.log('Querying for jobs on station date', {siteId, stationName, compareDate});
    var ref = db.collection('pressjobs')
        .where('printingEnd', '>=', startDate)
        .where('printingEnd', '<=', endDate)
        .orderBy("printingEnd", "desc").limit(limit ? limit : MAX_QUERY);

    try {
        var snasphot = await ref.get();
        for(const doc of snasphot.docs){
            const job = {id: doc.id, ...doc.data()};
            //console.log('Pushing job data', job);
            jobs.push(job);
        }
    } catch (error) {
        console.log(error);
        throw("Error getting documents: ", error);
    }

    // Fix dates
    parseAllDatesDoc(jobs);

    return {data: jobs};

}


export const getJobs = async (station, hours, limit=100) => {

    var beginningDate = Date.now() - hours * 60 * 60 * 1000;
    var beginningDateObject = new Date(beginningDate);

    return getJobsBetween(station, beginningDateObject, null, limit);

}

/**
 * Searches for all jobs in the pressjobs table in a certain time frame
 * across all sites and stations
 *
 * @param hours
 * @param limit
 * @returns {Promise<{data: []}>}
 */
export const getAllRecentJobs = async (hours, limit=100) => {

    var beginningDate = Date.now() - hours * 60 * 60 * 1000;
    var beginningDateObject = new Date(beginningDate);

    return getAllJobsBetween(beginningDateObject, null, limit);

}
